// removed by extract-text-webpack-plugin
module.exports = {"content":"DriverQuotes__content___1vL1r","leftContent":"DriverQuotes__leftContent___1XeC5","rightContent":"DriverQuotes__rightContent___3jHXx"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/DriverQuotes.css
// module id = 1549
// module chunks = 0